// Image are specified relative to a base URL, which is passed to
// ConfigProvider and used by components to resolve image URLs.

export default {
    exit: '/exit.jpg',
};
